module.exports = __webpack_public_path__ + "img/strawberry.be5030ca.webp";